import { inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { AuthService }  from "../auth/auth.service";

export const AuthGuard: CanActivateFn = async() => {


  console.log('getting here')
  const authService =  inject(AuthService);
  const router = inject(Router);

  const user = await authService.fetchUser();
  authService.user.set(user);

  if (!user) {
    router.navigate(['./auth']);
    return false;
  }

  

  return true;
}
